import React from 'react'

const BookingFees = () => {
  return <h2>Booking Fees</h2>
}

export default BookingFees
